export default {"src":"/_next/static/media/leave.1347ec41.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};